import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  formatDate,
  formatNumber,
  getAlertMessageFunction,
  getCurrentYear,
  getDeleteDialogConfig,
  handleNumberChange,
} from '../../../common/Util';
import { SelectBox } from '../../../components/common/SelectBox';
import TextField from '../../../components/common/TextField';
import { htm007Options } from '../../../common/data';
import DatePicker from '../../../components/common/DatePicker';
import { setIsDataModified } from '../../common/commonSlice';

export const renderField = (field, value, onChange, disabled) => {
  let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';

  if (field.input === 'selectBox') {
    let codeList = [...field?.options];
    if (!disabled && field.key == 'htmKFlag') {
      codeList = codeList.filter(item => item.value != '1');
    }

    return (
      <SelectBox
        label={field.label}
        value={fieldValue}
        onChange={e => onChange(e.target.value)}
        options={codeList}
        size="medium"
        disabled={disabled || field.disabled}
      />
    );
  }

  return (
    <TextField
      label={field.label}
      value={field.isNumber ? formatNumber(value || '') : value || ''}
      onChange={e => {
        if (field.isNumber) {
          handleNumberChange(e.target.value, onChange);
        } else {
          onChange(e.target.value);
        }
      }}
      size="small"
      disabled={disabled || field.disabled}
    />
  );
};

export const handleChange = (index, field, value, setDataList, dispatch) => {
  dispatch(setIsDataModified(true));

  setDataList(prev =>
    prev.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [field]: value,
        };
      }
      return item;
    }),
  );
};

export const handleAddButton = (setDataList, initData) => {
  setDataList(prev => [...prev, initData]);
};

export const handleDeleteButton = (
  dataIndex,
  setDataList,
  tCommon,
  dispatch,
  dataList,
  htmFlag,
) => {
  let apiDelete = false;
  dataList[dataIndex].htmSeq != '' ? (apiDelete = true) : (apiDelete = false);

  if (apiDelete) {
    let formData = [
      {
        htmSeq: dataList[dataIndex].htmSeq,
        htmFlag: htmFlag,
      },
    ];

    const resultAction = dispatch(getDeleteDialogConfig(tCommon, 'otherDeductions', { formData }));
    // if (resultAction.resultCode === 'OK') {
    //   alertMessage(tCommon('alertMessage.deleteSuccess'), 'success');
    //   // onClose();
    // } else {
    //   alertMessage(tCommon('alertMessage.deleteFail'), 'error');
    // }
    return;
  }

  setDataList(prev => {
    const newData = [...prev];
    newData.splice(dataIndex, 1);
    return newData;
  });
};

//연금, 장기
export const renderField01 = (field, value, onChange, flag, bankList, disabled, data) => {
  let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';

  if (field.input === 'selectBox') {
    let codeList = [...field?.options];
    // if (!disabled && field.key == 'htmKFlag') {
    //   codeList = codeList.filter(item => item.value != '1');
    // }

    //금융기관
    if (flag == '1' && field.key == 'htm002') {
      return (
        <SelectBox
          size="medium"
          label={field.label}
          value={fieldValue}
          disabled={disabled || field.disabled}
          onChange={e => onChange(e.target.value)}>
          {bankList.map((item, index) => (
            <option key={index} value={item.bankCd?.trim()}>
              {item.bankNm}
            </option>
          ))}
        </SelectBox>
      );
    }

    return (
      <SelectBox
        label={field.label}
        value={fieldValue}
        onChange={e => onChange(e.target.value)}
        options={codeList}
        size="medium"
        disabled={field.key == 'htmKFlag' || disabled || field.disabled}
      />
    );
  }

  if (field.isDate) {
    return (
      <DatePicker
        disabled={disabled}
        value={formatDate(fieldValue?.replaceAll('-', ''))}
        name={field.key}
        label={field.label}
        onChange={e => onChange(e.target.value)}
      />
    );
  }

  //연금저축이고, ISA 만기전환 납입금액
  if (flag == '1' && field.key == 'htm010') {
    return (
      <TextField
        label={field.label}
        value={field.isNumber ? formatNumber(value || '') : value || ''}
        onChange={e => {
          if (field.isNumber) {
            handleNumberChange(e.target.value, onChange);
          } else {
            onChange(e.target.value);
          }
        }}
        size="small"
        disabled={!(data.htm001 == '8' || data.htm001 == '9') || disabled || field.disabled}
      />
    );
  }

  return (
    <TextField
      label={field.label}
      value={field.isNumber ? formatNumber(value || '') : value || ''}
      onChange={e => {
        if (field.isNumber) {
          handleNumberChange(e.target.value, onChange);
        } else {
          onChange(e.target.value);
        }
      }}
      size="small"
      disabled={disabled || field.disabled}
    />
  );
};

//연금 validata
export const isValidate = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();

  const hasError = dataList.some(data => {
    const { htmKFlag, htm001, htm002, htm003, htm004, htm010 } = data;

    //국세청구분을 선택 X
    if (htmKFlag == '') {
      alertMessage(t('alertMessage01'));
      return true;
    }

    //저축구분 선택 X
    if (htm001 == '') {
      alertMessage(t('alertMessage02'));
      return true;
    }

    //금융기관을 입력하셔야 합니다.
    if (htm002 == '' && htm001 != '5') {
      alertMessage(t('alertMessage03'));
      return true;
    }

    //계좌번호를 입력하셔야 합니다.
    if (htm003 == '' && htm001 != '5') {
      alertMessage(t('alertMessage04'));
      return true;
    }

    //계좌번호/증권번호 입력란에 숫자와 대문자 알파벳만 입력해주세요.
    if (!/^[A-Z0-9]+$/.test(htm003) && htm001 != '5') {
      alertMessage(t('alertMessage05'));
      return true;
    }

    //납입금액을 입력하셔야 합니다.
    if (htm004 == '') {
      alertMessage(t('alertMessage06'));
      return true;
    }

    return false;
  });

  return !hasError;
};

//장기집합 validate
export const isValidate02 = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();

  const hasError = dataList.some(data => {
    const {
      htmKFlag,
      htmFlag,
      htm001,
      htm002,
      htm003,
      htm004,

      htm013,
    } = data;

    let htm012 = formatDate(data.htm012?.replaceAll('-', ''));
    //국세청구분을 선택 X
    if (htmKFlag == '') {
      alertMessage(t('alertMessage01'));
      return true;
    }

    //저축구분 선택 X
    if (htmFlag == '') {
      alertMessage(t('alertMessage02'));
      return true;
    }

    //금융기관을 입력하셔야 합니다.
    if (htm002 == '') {
      alertMessage(t('alertMessage03'));
      return true;
    }

    //계좌번호를 입력하셔야 합니다.
    if (htm003 == '') {
      alertMessage(t('alertMessage04'));
      return true;
    }

    //계좌번호/증권번호 입력란에 숫자와 대문자 알파벳만 입력해주세요.
    if (!/^[A-Z0-9]+$/.test(htm003)) {
      alertMessage(t('alertMessage05'));
      return true;
    }

    //납입금액을 입력하셔야 합니다.
    if (htm004 == '') {
      alertMessage(t('alertMessage06'));
      return true;
    }

    //가입일자 또는 계약기간월수를 입력하셔야 합니다.
    if (htmFlag == 'C' && (htm012 == '' || htm013 == '')) {
      alertMessage(t('alertMessage07'));
      return true;
    }

    //올바른 가입일자를 입력하세요.
    if (
      (htmFlag == 'C' && htm012.replaceAll('-', '').length != 8) ||
      (htmFlag != 'C' && htm012.replaceAll('-', '').length != 8)
    ) {
      alertMessage(t('alertMessage08'));
      return true;
    }

    //가입일자가 2025년 이후인 경우 장기집합투자증권 입력이 불가합니다.
    if (htm012.substring(0, 4) > getCurrentYear()) {
      alertMessage(t('alertMessage13'));
      return true;
    }

    //청년형 장기집합투자증권의 계약기간월수는 2자리 이하만 입력가능합니다.
    if (htmFlag == 'C' && htm013.trim().length > 2) {
      alertMessage(t('alertMessage09'));
      return true;
    }

    //장기집합투자증권의 계약기간월수는 3자리 이하만 입력가능합니다.
    if (htmFlag == 'F' && htm013.trim().length > 3) {
      alertMessage(t('alertMessage10'));
      return true;
    }

    return false;
  });

  return !hasError;
};

//투자조합
export const isValidate03 = (dataList, t) => {
  const alertMessage = getAlertMessageFunction();

  const hasError = dataList.some(data => {
    const { htmKFlag, htm007, htm008, htm004, htm003 } = data;

    console.log('data >>', data);
    //국세청 구분을 선택하셔야 합니다.
    if (htmKFlag == '') {
      alertMessage(t('alertMessage01'));
      return true;
    }

    //투자연도를 입력하셔야 합니다.
    if (htm007 == '') {
      alertMessage(t('alertMessage11'));
      return true;
    }

    //투자구분을 선택하셔야 합니다.
    if (htm008 == '') {
      alertMessage(t('alertMessage12'));
      return true;
    }

    //계좌번호/증권번호 입력란에 숫자와 대문자 알파벳만 입력해주세요.
    if (!/^[A-Z0-9]+$/.test(htm003)) {
      alertMessage(t('alertMessage05'));
      return true;
    }

    //납입금액을 입력하셔야 합니다.
    if (htm004 == '') {
      alertMessage(t('alertMessage06'));
      return true;
    }

    return false;
  });

  return !hasError;
};
